module.exports = __webpack_public_path__ + "static/media/24-mobile.b73705ac.jpg";